/**
 * Order query key factory
 */
export const orderKeys = {
  all: ["orders"] as const,
  details: () => [...orderKeys.all, "detail"] as const,
  detail: (id: string) => [...orderKeys.details(), id] as const,
} as const;
